import { E_SKUTAG, ORDER_STATE_ENUM, ORDER_REFUND_STATE_ENUM } from '@/config'
export default class {
  /**
   * 订单详情页不展示服务人员和服务人员电话
   * 4 5 6 7 8 9 10均不展示
   * @param {string | number} skuTag
   */
  static showServeInfo(skuTag) {
    return (
      +skuTag !== E_SKUTAG.POPHOME &&
      +skuTag !== E_SKUTAG.POPTRAIN &&
      +skuTag !== E_SKUTAG.POPENTITY &&
      +skuTag !== E_SKUTAG.POPSTORE &&
      +skuTag !== E_SKUTAG.TRAVEL_TICKET &&
      +skuTag !== E_SKUTAG.ONLINE_EDU_9 &&
      +skuTag !== E_SKUTAG.UNIONHOME &&
      +skuTag !== E_SKUTAG.STORE_SPECIAL
    )
  }
  static showStoreInfo(skuTag) {
    return +skuTag === E_SKUTAG.POPTRAIN || +skuTag === E_SKUTAG.POPSTORE
  }
  static isUseCustomSignature(skuTag) {
    return +skuTag === E_SKUTAG.POPTRAIN || +skuTag === E_SKUTAG.POPSTORE
  }
  static showAddressInfo(skuTag) {
    return (
      +skuTag == E_SKUTAG.SELFHOME ||
      +skuTag == E_SKUTAG.POPYUSAO ||
      +skuTag == E_SKUTAG.POPENTITY ||
      +skuTag == E_SKUTAG.ONLINE_EDU_9 ||
      +skuTag == E_SKUTAG.UNIONHOME ||
      +skuTag == E_SKUTAG.APPLIANCE_WASHING ||
      +skuTag == E_SKUTAG.STORE_SPECIAL
    )
  }
  /**
   * 是否展示核销码
   * 订单待服务20且未退单10或者是退单失败40 都展示核销码
   * @param {string | number} orderState
   * @param {string | number} refundState
   */
  static isShowBarCodeModule(orderState, refundState) {
    return (
      ORDER_STATE_ENUM.TO_BE_USED == orderState &&
      (ORDER_REFUND_STATE_ENUM.NOT_APPLIED == refundState ||
        ORDER_REFUND_STATE_ENUM.FAILED == refundState)
    )
  }
}
